import '../styles/lbdo-main.scss';
import { docReady } from './helpers/docReady';
import { typeStyles } from './sections/image-hero';
import ListeningPlayers from './sections/featured-listening';
import { marqueeSection } from './sections/marquee';
import { productItem } from './snippets/product-item';
docReady(() => {
    typeStyles();
    ListeningPlayers.init();
    marqueeSection();
    productItem();
});
